import React from 'react';
import type { Color, PieceType } from '@/types';
import styles from './Promotion.module.css';

interface PromotionProps {
  color: Color;
  onSelect: (piece: PieceType) => void;
  onCancel: () => void;
}

const promotionPieces: PieceType[] = ['queen', 'rook', 'bishop', 'knight'];

const pieceUnicode: Record<string, string> = {
  'white-queen': '♕',
  'white-rook': '♖',
  'white-bishop': '♗',
  'white-knight': '♘',
  'black-queen': '♛',
  'black-rook': '♜',
  'black-bishop': '♝',
  'black-knight': '♞',
};

export const Promotion: React.FC<PromotionProps> = ({ color, onSelect, onCancel }) => {
  return (
    <>
      <div className={styles.overlay} onClick={onCancel} />
      <div className={styles.modal}>
        <h3 className={styles.title}>Choose promotion piece</h3>
        <div className={styles.pieces}>
          {promotionPieces.map(piece => (
            <button
              key={piece}
              className={styles.pieceButton}
              onClick={() => onSelect(piece)}
            >
              <span className={`${styles.piece} ${styles[color]}`}>
                {pieceUnicode[`${color}-${piece}`]}
              </span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};